import {
  CustomError,
  extractServerGraphQLErrors,
} from '../../util/throwIfCustomError'

export function passkeyAuthenticationError(error: unknown): string | null {
  if (error instanceof CustomError && error.code === 'UNAUTHENTICATED') {
    const reason = error.extensions['reason']
    return typeof reason === 'string' ? reason : 'TOKEN_INVALID'
  }
  const authenticationError = extractServerGraphQLErrors(error).find(
    (item) => item.extensions?.['code'] === 'UNAUTHENTICATED',
  )
  if (authenticationError) {
    const reason = authenticationError.extensions?.['reason']
    return typeof reason === 'string' ? reason : 'TOKEN_INVALID'
  }
  return null
}

export function passkeyErrorMessage(error: unknown): string {
  if (error instanceof Error && error.name === 'NotAllowedError')
    return '操作がキャンセルされたか、時間切れになりました。再度お試しください。'
  if (
    error instanceof Error &&
    (error.name === 'InvalidStateError' ||
      ('code' in error &&
        error.code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED'))
  )
    return 'この端末のパスキーは登録済みです。別の端末かセキュリティキーで登録してください'
  if (error instanceof CustomError) {
    if (error.code === 'RATE_LIMITED')
      return '試行回数が多すぎます。しばらく待ってから再度お試しください。'
    if (error.code === 'PASSKEY_NOT_ALLOWED')
      return '現在の認証状態または組織の設定では、パスキーを利用できません。登録可能な認証方法をご確認ください。'
    if (error.code === 'BAD_USER_INPUT')
      return '入力内容を確認し、再度お試しください。'
  }
  return 'パスキーの操作に失敗しました。再度お試しください。'
}
